import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { driverVersions } from 'app/registries/consts/tabular-consts';
import { LinkedServiceUtils } from './linked-service.utils';

export enum xeroAuthType {
    OAuth_1_0 = 'OAuth_1.0',
    OAuth_2_0 = 'OAuth_2.0'
}
@Metamodel.model({
    name: 'Xero',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Xero_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Xero_DisplayText)
    ]
})
export class XeroLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.DriverVersion
    })
    public version?: string = driverVersions.v2;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public host?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public consumerKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public privateKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_TenantId
    })
    public tenantId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: stringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    public authType?: xeroAuthType = xeroAuthType.OAuth_1_0;

    public isOldResource: boolean = false;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): XeroLinkedService {
        return LinkedServiceUtils.commonV1ToV2(context, this) as XeroLinkedService;
    }
}
